import React from 'react';

interface MenuButtonProps {
    title: string;
    className: string;
    style: {};
    onClick?: () => void;
}

function ButtonsForTabs(props: MenuButtonProps) {
    const { title, className, style, onClick } = props;

    return (
        <div className="tab-button">
            <input
                type="submit"
                className={`tab-button-input ${className}`}
                style={{ ...style, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}
                title={title}
                value=""
                onClick={onClick}
            />
        </div>
    );
}

export default ButtonsForTabs;
